import { Component, HostBinding, Input } from '@angular/core';
import { IMailRecipientItem } from '@app/main/org-tree/org-communication-settings/mail-recipient-list/mail-recipient-list.component';
import { PageEvent } from '@angular/material/paginator';
import { animate, animateChild, query, style, transition, trigger } from '@angular/animations';

@Component({
    selector: 'app-recipient-item',
    templateUrl: './recipient-item.component.html',
    styleUrls: ['./recipient-item.component.scss'],
    animations: [
        trigger('itemGone', [
            transition('* -> void', [
                query('.recipient-item', [
                    style({ overflow: 'hidden', transform: 'none', visibility: 'hidden' }),
                    animate(
                        '700ms cubic-bezier(0.35, 0, 0.25, 1)',
                        style({
                            height: 0,
                            transform: 'scaleY(0) translateY(100%)',
                            'transform-origin': 'top',
                            'padding-top': 0,
                            'padding-bottom': 0
                        })
                    ),
                    animateChild()
                ])
            ])
        ]),
        trigger('comeUp', [
            transition(':decrement, :increment', [
                query('.recipient-item', [
                    style({ opacity: 0 }),
                    animate('700ms cubic-bezier(0.35, 0, 0.25, 1)', style({ opacity: 1 }))
                ])
            ])
        ]),
        trigger('slide', [
            transition('void -> *', [
                query(
                    '.recipient-item',
                    [
                        style({ opacity: 1, transform: 'translateX({{fromPercentage}}%)' }),
                        animate(
                            '300ms cubic-bezier(0.35, 0, 0.25, 1)',
                            style({
                                opacity: 1,
                                transform: 'translateX({{toPercentage}}%)'
                            })
                        )
                    ],
                    { optional: true }
                )
            ])
        ])
    ],
    standalone: false
})
export class RecipientItemComponent {
    cssClass: { [key: string]: boolean } = {};
    @Input() count = 20;
    @Input() zIndex: number;
    toRecipients = '';
    ccRecipients = '';
    bccRecipients = '';
    private _firstIndex = true;

    private _slide: { value: any; params?: { [key: string]: any } } = {
        value: null,
        params: { fromPercentage: 0, toPercentage: 0 }
    };

    @HostBinding('@slide') get slide() {
        return this._slide;
    }

    private _pageEvent: { event: PageEvent; nextPage: boolean };

    get pageEvent(): { event: PageEvent; nextPage: boolean } {
        return this._pageEvent;
    }

    @Input() set pageEvent(item: { event: PageEvent; nextPage: boolean }) {
        this._slide = {
            value: item.event,
            params: { fromPercentage: item.nextPage ? '100' : '-100', toPercentage: item.nextPage ? '0' : '0' }
        };
        this._pageEvent = item;
    }

    private _comeUp: { value: any; params?: { [key: string]: any } };

    @HostBinding('@comeUp') get comeUp() {
        return this._comeUp;
    }

    set comeUp(val) {
        this._comeUp = val;
    }

    private _index: { index: number; pageChange: boolean } = null;

    get index(): { index: number; pageChange: boolean } {
        return this._index;
    }

    @Input() set values(value: { index: number; pageChange: boolean }) {
        if ((value && value?.index >= 0 && !this._firstIndex) || this._index?.index !== value?.index) {
            const toIndex = (this._index?.index % this.count) - (value?.index % this.count);

            if (!value?.pageChange) {
                this.comeUp = { value, params: { percentage: toIndex * 100 } };
            }

            this._index = value;
            this._firstIndex = false;
        }
    }

    private _item: IMailRecipientItem;

    get item(): IMailRecipientItem {
        return this._item;
    }

    @Input() set item(val: IMailRecipientItem) {
        this._item = val;

        const countToRecipients = val.to?.length;
        this.toRecipients = val.to?.slice(0, 2).join(', <br>');

        if (countToRecipients > 2) {
            this.toRecipients += ` + ${countToRecipients - 2}`;
        }

        const countCCRecipients = val.cc?.length;
        this.ccRecipients = val.cc?.slice(0, 2).join(', <br>');

        if (countCCRecipients > 2) {
            this.ccRecipients += ` + ${countCCRecipients - 2}`;
        }

        const countBCCRecipients = val.bcc?.length;
        this.bccRecipients = val.bcc?.slice(0, 2).join(', <br>');

        if (countBCCRecipients > 2) {
            this.bccRecipients += ` + ${countBCCRecipients - 2}`;
        }
    }

    get placeholder(): boolean {
        return this.cssClass.placeholder;
    }

    @Input() set placeholder(val: boolean) {
        this.cssClass.placeholder = val;
    }

    async viewMail() {
        /*		const item: IScheduledJobRecipient = this.item as IScheduledJobRecipient;
				const result = await this.jobsService.getContentForRecipient(this.singleDataItem.id, item.id);
				this.jobsComponentService.showMailData.next(result);*/
    }
}
